"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const DiscountsController_1 = __importDefault(require("./DiscountsController"));
exports.default = DiscountsController_1.default;
